import React, {PropTypes} from 'react';
import Levels from './levels';
import Steps from './steps';
import Chart from './chart';
import LevelDescription from './level-description';
import Included from './included';
import Translate from 'react-translate-component';

class LoyaltyPointsOverview extends React.Component {
  static propTypes = {
    points: PropTypes.number.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      selectedLevel: null,
      currentLevelIndex: null
    };

    this.setSelectedLevel = this.setSelectedLevel.bind(this);
  }

  levels = [
    {
      icon: require('images/icons/heart.svg'),
      title: 'LOYALTY_TITLE_1',
      pointsLabel: <Translate content='LOTALTY_START_LEVEL' />,
      points: 0,
      nextLevelPoints: 100000
    },
    {
      icon: require('images/icons/invoicery.svg'),
      title: 'LOYALTY_TITLE_2',
      pointsLabel: '100 000',
      points: 100000,
      nextLevelPoints: 250000
    },
    {
      icon: require('images/icons/share.svg'),
      title: 'LOYALTY_TITLE_3',
      pointsLabel: '250 000',
      points: 250000,
      nextLevelPoints: 500000
    },
    {
      icon: require('images/icons/cloud.svg'),
      title: 'LOYALTY_TITLE_4',
      pointsLabel: '500 000',
      points: 500000,
      nextLevelPoints: 1000000
    },
    {
      icon: require('images/icons/plane.svg'),
      title: 'LOYALTY_TITLE_5',
      pointsLabel: '1 000 000',
      points: 1000000,
      nextLevelPoints: 1500000
    },
    {
      icon: require('images/icons/rocket.svg'),
      title: 'LOYALTY_TITLE_6',
      pointsLabel: '1 500 000',
      points: 1500000
    }
  ];

  componentDidMount () {
    const currentLevelIndex = this.levels
      .findIndex((level) => level.points <= this.props.points && level.nextLevelPoints > this.props.points);
    this.setState({
      selectedLevel: currentLevelIndex,
      currentLevelIndex: currentLevelIndex
    });
  }

  setSelectedLevel (level) {
    this.setState({
      selectedLevel: level
    });
  }

  render () {
    return (
      <div className='loyalty-points-overview'>
        <div className='loyalty-points-overview-container'>
          <div className='loyalty-points-overview-levels-container'>
            <Steps points={this.props.points} />
            <Levels
              points={this.props.points}
              selected={this.state.selectedLevel}
              setSelectedLevel={this.setSelectedLevel}
              levels={this.levels}
              currentLevelIndex={this.state.currentLevelIndex}
            />
            <div>
              <Chart
                levels={this.levels}
                points={this.props.points}
                currentLevelIndex={this.state.currentLevelIndex}
              />
              <LevelDescription selected={this.state.selectedLevel} />
            </div>
          </div>
        </div>
        <Included />
      </div>
    );
  }
}

export default LoyaltyPointsOverview;



/** WEBPACK FOOTER **
 ** ./src/views/loyalty-program/overview/overview.js
 **/